<template>
  <div class="outerLayer">
    <div class="outerLayer_titleArea">
      <div class="left">
        <!-- <span>图片</span> -->
      </div>
      <div class="right">
        <!-- temporary ||  -->
        <el-button
          type="success"
          icon="el-icon-upload"
          @click="$refs.file.click()"
        >上传<input
          id="fileinput"
          ref="file"
          style="display: none"
          type="file"
          multiple
          accept="image/gif,image/jpg,image/jpeg,image/png"
          @change="uploadPictures"
        ></el-button>
      </div>
    </div>
    <div class="outerLayer_groupingArea">
      <div class="left">
        <span class="left_title">是否公用：</span>
        <ul class="left_ul">
          <li
            v-for="(type, index) in is_public_type"
            :key="index"
            class="ul_li"
            :class="{ active: pageIfon.is_public == index }"
            @click="lewrurl(index)"
          >
            {{ type }}
          </li>
        </ul>
      </div>
    </div>
    <div class="outerLayer_groupingArea">
      <div class="left">
        <span class="left_title">类型：</span>
        <ul class="left_ul">
          <li
            v-for="(type, index) in typelist"
            :key="index"
            :class="{ active: pageIfon.type == index }"
            class="ul_li"
            @click="wrwtype(index)"
          >
            {{ type }}
          </li>
        </ul>
      </div>
    </div>
    <div class="outerLayer_groupingArea">
      <div class="left">
        <span class="left_title">业务类型：</span>
        <ul class="left_ul">
          <li
            v-for="(value, key) in business_type"
            :key="key"
            :class="{ active: pageIfon.business_type == key }"
            class="ul_li"
            @click="wrw(key)"
          >
            {{ value }}
          </li>
        </ul>
      </div>
      <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
    </div>
    <div class="outerLayer_groupingArea">
      <div class="left">
        <span class="left_title">尺寸（宽、高）：</span>
        <ul class="left_ul">
          <li
            v-for="(type, index) in size_type"
            :key="index"
            class="ul_li"
            :class="{ active: sizeSign == index }"
            @click="changesize(type, index)"
          >
            {{ type }}
          </li>
        </ul>
      </div>
    </div>
    <div class="outerLayer_mainArea">
      <!-- <div v-if="select.length" class="mainArea_deleteArea">
        <div class="box">
          <span
            class="deleteArea_choice"
            :class="{
              have:select.length > 0,
              whole:isWhole
            }"
            @click="whole"
          />
          <span>已选择{{ select.length }}项内容</span>
          <span class="deleteArea_cancel" @click="select = []">取消选择</span>
        </div>
        <span class="delete">删除</span>
      </div> -->

      <div v-loading="loading" class="mainArea_main">
        <ul class="main_ul">
          <!-- <li
            v-if="temporary"
            class="temporary"
          >
            <img
              v-if="temporary !== '多张'"
              class="li_img"
              :src="temporary"
              @click="handitem(item.path,item.id)"
            >
            <span
              v-else
              style="position: absolute;left: 50%;transform: translateX(-50%);font-size: 20px;font-weight: bold;"
            >多张</span>
            <span
              ref="men"
              class="men"
            />
          </li> -->
          <li
            v-for="item in datas"
            :key="item.id"
            class="ul_li"
            @click="addDta(item)"
          >
            <div
              v-if="getFileType(item.path) === 'image'"
              style="text-align: center"
              :class="{ active: select.includes(item.id) }"
            >
              <div>
                <img
                  class="li_img"
                  :src="item.path"
                  @click="
                    handitem(item.path, item.id, item.original_name, item)
                  "
                >
                <span class="li_span">
                  <i
                    v-if="select.includes(item.id)"
                    class="el-icon-check"
                    style="color: #fff"
                  />
                </span>
              </div>
              <div
                style="
                  width: 150px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <span>名称：{{ item.original_name }}</span>
              </div>
            </div>
            <div v-else-if="getFileType(item.path) === 'audio'">
              <div class="li_left">
                <span>{{
                  item.path.slice(
                    item.path.indexOf('--') + 2,
                    item.path.indexOf('.mp3')
                  )
                }}</span>
                <span>{{
                  item.createdAtTime.slice(0, item.createdAtTime.indexOf(' '))
                }}</span>
              </div>
              <div class="li_right">
                <i
                  class="right_icon el-icon-video-play"
                  :class="{
                    'el-icon-video-pause': selece && item.id === selece.id
                  }"
                  @click="broadcastTemporarily(item)"
                />
                <span>{{ item.duration }}</span>
              </div>
            </div>
            <div v-else-if="getFileType(item.path) === 'video'">
              <video
                controls
                style="width: 150px; max-height: 150px"
                :src="item.path"
                video
                @click="handitem(item.path, item.id, item.name, item)"
              />
              <div
                style="
                  width: 150px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <span>名称：{{ item.original_name }}</span>
              </div>
            </div>
          </li>
          <span v-if="datas && datas.length === 0">暂无数据</span>
        </ul>
      </div>
      <PaginationRight
        style="position: absolute; bottom: 0px; right: 0px"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
// import { getMaterialLibraryList, newMateriallist, materialroadtype } from '@/api/sourceMaterial.js'
import {
  getMaterialLibraryList,
  upload,
  uploadadd
} from '@/api/sourceMaterial.js'
// import { qiniuToken } from '@/api/qiniuToken.js'
// import * as qiniu from 'qiniu-js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import getNowDate from '@/utils/mixins/convertToHump.js'
// import axios from 'axios'
export default {
  components: {
    PaginationRight
  },
  mixins: [getNowDate],
  data() {
    return {
      datas: [], // 列表数据
      pageIfon: {
        page: 1,
        pageSize: 10,
        is_public: 1,
        business_type: 1,
        type: 1,
        height: null,
        weight: null
      },
      temporary: null,
      select: [],
      token: null,
      total: null,
      loading: false,
      typelist: {},
      business_type: {},
      size_type: {
        1: '全部',
        2: '512*512',
        3: '800*800',
        4: '720*1280',
        5: '1280*720'
      },
      tabPosition: 'bottom',
      is_public_type: {},
      sizeSign: 1
    }
  },
  computed: {
    isWhole() {
      const newArr = this.datas.filter((item) => this.select.includes(item.id))
      return newArr.length === this.datas.length
    },
    getFileType() {
      return (path) => {
        const extension = path
          .substring(path.lastIndexOf('.') + 1)
          .toLowerCase()
        if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
          return 'image'
        } else if (['mp4', 'mov', 'avi'].includes(extension)) {
          return 'video'
        } else if (['mp3', 'wav'].includes(extension)) {
          return 'audio'
        } else {
          return 'other'
        }
      }
    }
  },
  created() {
    // this.getQiniuToken()
    this.getlist()
    // this.mawlist()
    window.aa = this
  },
  methods: {
    parentHandleclick(e, business_type) {
      console.log('business_type:', business_type)
      if (business_type !== undefined) {
        this.pageIfon.business_type = business_type
      }
      console.log(e)
      this.typer = e
      this.getlist()
    },
    async getlist() {
      this.loading = true
      console.log(111, this.pageIfon)
      getMaterialLibraryList(this.pageIfon)
        // {
        //   business_type: this.pageIfon.business_type === '常用类型' ? 1 : this.pageIfon.business_type === '头像类型' ? 2 : this.pageIfon.business_type === '公众号类型' ? 3 : '',
        //   is_public: this.pageIfon.is_public,
        //   type: this.pageIfon.type === '图片' ? 1 : this.pageIfon.type === '音频' ? 2 : this.pageIfon.type === '视频' ? 3 : ''
        // }
        .then((data) => {
          console.log('data:', data.data)
          this.loading = false
          this.typelist = data.data.config.material_type
          this.is_public_type = data.data.config.is_public_type
          this.business_type = data.data.config.business_type
          this.datas = data.data.list
          this.total = data.data.count
        })
        .catch((error) => {
          console.log('error:', error.response)
          console.error('Error:', error)
        })
    },
    handitem(img, key, name, item) {
      console.log(1111)
      if (this.typer === '1') {
        this.$emit('clickicon', img, key, name, item)
      } else if (this.typer === '2') {
        this.$emit('kefuicon', img, key, item)
      } else {
        this.$emit('imgcallback', img, key, item)
      }
    },
    async uploadPictures(e) {
      console.log(this.getNowDate())

      for (let i = 0; i < e.target.files.length; i++) {
        const fileIfon = e.target.files[i]
        const img = new Image()
        const reader = new FileReader()

        // 设置图片源为读取的文件数据
        const temporary =
          e.target.files.length > 1
            ? '多张'
            : window.URL.createObjectURL(fileIfon)
        temporary !== '多张' && (img.src = temporary)
        this.temporary = temporary

        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.'))
        let type = ''

        if (['.jpg', '.jpeg', '.png', '.gif'].includes(ftype.toLowerCase())) {
          // 图像文件
          type = 1
        } else if (
          ['.mp3', '.wav', '.flac', '.aac'].includes(ftype.toLowerCase())
        ) {
          // 音频文件
          type = 2
        } else if (
          ['.mp4', '.avi', '.mkv', '.mov'].includes(ftype.toLowerCase())
        ) {
          // 视频文件
          type = 3
        } else {
          type = ''
          this.$message({
            message: '请上传正确的上传格式(视频、音频、图像)',
            type: 'error'
          })
          return
        }

        let videoWidth = 0
        let videoHeight = 0
        const videoElement = document.createElement('video')
        let duration = '0'
        if (type !== 1) {
          videoElement.src = URL.createObjectURL(fileIfon)
          videoElement.addEventListener('loadedmetadata', function() {
            duration = videoElement.duration // 视频时长（以秒为单位）
          })
          videoElement.addEventListener('loadedmetadata', function() {
            videoWidth = videoElement.videoWidth // 视频宽度（以像素为单位）
          })
        } else {
          img.onload = () => {
            if (img.width !== 0) {
              videoWidth = img.width
              console.log('videoWidth:', videoWidth)
              videoHeight = img.height
            }
          }
        }
        if (type !== '') {
          console.log('type:', type)
          if (type === 3) {
            videoElement.addEventListener('loadedmetadata', function() {
              videoWidth = videoElement.videoWidth // 视频宽度（以像素为单位）
              videoHeight = videoElement.videoHeight // 视频高度（以像素为单位）
            })
          } else {
            reader.onload = function(e) {
              // 创建一个 Image 对象
              const img = new Image()

              // 图片加载完成后的回调函数
              img.onload = function() {
                // 获取图片的宽高
                videoWidth = img.width
                videoHeight = img.height

                img.src = e.target.result
              }
            }
            reader.readAsDataURL(fileIfon)
            // img.onload = () => {
            //   videoWidth = img.width
            //   videoHeight = img.height
            // }
          }

          console.log(1, videoWidth, videoHeight, '4')
          const formdata = new FormData()
          formdata.append('file', fileIfon)
          upload(formdata)
            .then(async(data) => {
              console.log('data:', data)
              if (!data.success) return
              await uploadadd({
                type,
                size: data.data.size,
                path: data.data.path,
                name: data.data.name,
                weight: videoWidth,
                height: videoHeight,
                duration,
                md5: data.data.md5,
                original_name: data.data.original_name,
                business_type: this.pageIfon.business_type
              })
              // this.datas = []
              this.getlist()
            })
            .catch((res) => {
              console.log('res:', res)
            })
        } else {
          console.log(11)
        }
      }
    },
    addDta(item) {
      if (this.select.includes(item.id)) {
        const index = this.select.indexOf(item.id)
        this.select.splice(index, 1)
      } else {
        this.select.push(item.id)
      }
    },

    whole() {
      const newArr = this.datas.filter((item) => this.select.includes(item.id))
      if (newArr.length === this.datas.length) {
        this.datas.forEach((item) => {
          const index = this.select.indexOf(item.id)
          this.select.splice(index, 1)
        })
      } else {
        this.datas.forEach((item) => {
          this.select.includes(item.id) || this.select.push(item.id)
        })
      }
    },

    fetchPageSize(num) {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = num
      this.getlist()
    },
    fetchCurrentPage(num) {
      this.pageIfon.page = num
      this.getlist()
    },
    lewrurl(id) {
      this.pageIfon.page = 1
      this.pageIfon.is_public = id
      this.getlist()
    },
    changesize(id, i) {
      this.sizeSign = i
      // eslint-disable-next-line eqeqeq
      if (i == 1) {
        this.pageIfon.page = 1
        this.pageIfon.weight = 0
        this.pageIfon.height = 0
      } else {
        console.log('id:', id, i)
        const [variable1, variable2] = id.split('*')
        this.pageIfon.page = 1
        this.pageIfon.weight = variable1
        this.pageIfon.height = variable2
      }

      this.getlist()
    },
    wrw(id) {
      this.pageIfon.page = 1
      this.pageIfon.business_type = id
      this.getlist()
    },
    wrwtype(id) {
      this.pageIfon.page = 1
      this.pageIfon.type = id
      this.getlist()
    }
  }
}
</script>

<style lang="less" scoped>
* {
  list-style-type: none;
  box-sizing: border-box;
}
.active {
  // color: skyblue;
  border: 1px solid #67c23a;
  color: #67c23a;
}
.outerLayer {
  width: 99%;
  min-height: calc(100vh - 248px);
  background-color: #fff;
  padding: 15px;
  border-radius: 7px;
  box-shadow: 0px 0px 5px #ccc;
  margin: 0 auto;
  margin-top: 2px;
  margin-bottom: 2px;
  .outerLayer_titleArea {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .outerLayer_groupingArea {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left_title {
        font-size: 14px;
      }
      .left_ul {
        display: flex;
        align-items: center;
        .ul_li {
          list-style-type: none;
          // padding: 6px 10px;
          padding: 7px 10px 5px 10px;
          font-size: 13px;
          cursor: pointer;
          border-radius: 6px;
          // &:not(.active):hover{
          //  background-color: rgb(230, 230, 230);
          // }
          // .active{
          //   background-color: rgb(202, 202, 202);
          // }
        }
      }
    }
    .right {
      .right_span {
        font-size: 12px;
        padding: 6px 10px;
        border-radius: 5px;
        display: inline-block;
        cursor: pointer;
        &:hover {
          background-color: rgb(230, 230, 230);
        }
      }
    }
  }

  .outerLayer_mainArea {
    display: flex;
    align-items: center;
    font-size: 13px;
    justify-content: space-between;
    flex-direction: column;

    .box {
      display: flex;
      align-items: center;
    }

    .mainArea_deleteArea {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 13px 15px;
      background-color: rgb(231, 226, 226);
      .deleteArea_cancel {
        display: inline-block;
        margin-left: 15px;
        cursor: pointer;
      }

      .delete {
        cursor: pointer;
      }

      .deleteArea_choice {
        display: flex;
        width: 13px;
        height: 13px;
        box-shadow: 0px 0px 1px rgb(63, 63, 63);
        margin-right: 10px;
        cursor: pointer;
        position: relative;

        &.have {
          &::after {
            position: absolute;
            content: '';
            width: 50%;
            height: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: rgb(78, 211, 17);
          }
        }
        &.whole {
          &::after {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            background-color: rgb(78, 211, 17);
          }
        }

        &:hover {
          box-shadow: 0px 0px 2px black;
        }
      }
    }

    .mainArea_main {
      position: relative;
      width: 100%;
      .main_ul {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 0px;
        padding: 0px;

        .ul_li {
          //  width: 150px;
          //  height: 150px;
          position: relative;
          cursor: pointer;
          margin: 10px;
          display: flex;
          align-items: center;
          box-shadow: 0px 0px 1px black;

          //  &.active{
          //     &::after{
          //       position: absolute;
          //       content: '';
          //       width: 106%;
          //       height: 106%;
          //       // background-color: rgb(112 188 138 / 30%);
          //       z-index: 11;
          //       top: -4px;
          //       left: -4px;
          //     }

          //     .li_span{
          //       display: flex;
          //     }
          //  }

          //  &:not(.active):hover{
          //     &::after{
          //       position: absolute;
          //       content: '';
          //       width: 106%;
          //       height: 106%;
          //       background-color: rgb(112 188 138 / 30%);
          //       z-index: 11;
          //       top: -4px;
          //       left: -4px;
          //     }

          //     .li_span{
          //       display: flex;
          //     }
          //  }

          .li_img {
            width: 150px;
            height: 150px;
          }
          .li_video {
            width: 100%;
            height: 100%;
          }
          .li_audio {
            width: 100%;
            height: 100%;
          }
          .li_span {
            width: 15px;
            height: 15px;
            display: none;
            position: absolute;
            border: 1px solid black;
            top: 7px;
            left: 7px;
            z-index: 1111111;
            align-items: center;
            justify-content: center;
            background-color: rgb(11, 201, 43);
          }
        }
      }
    }

    .temporary {
      width: 150px;
      height: 150px;
      position: relative;
      margin: 10px;
      box-shadow: 0px 0px 1px #1f1f1f;
      display: flex;
      align-items: center;
      .men {
        position: absolute;
        width: 106%;
        height: 106%;
        background-color: rgba(150, 146, 146, 0.3);
        top: -4px;
        left: -4px;
        transition: all 1s;
        display: inline-block;
      }
      .li_img {
        width: 100%;
        /* height: 100%; */
      }
    }
  }
}
</style>
<style scoped lang="less">
* {
  list-style-type: none;
  box-sizing: border-box;
}
.outerLayer {
  width: 99%;
  min-height: calc(100vh - 248px);
  background-color: #fff;
  padding: 10px;
  border-radius: 7px;
  box-shadow: 0px 0px 5px #ccc;
  margin: 0 auto;
  margin-top: 2px;
  margin-bottom: 2px;

  .outerLayer_titleArea {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .titleArea_left {
    }
    .titleArea_right {
      display: flex;
      align-items: center;
    }
  }

  .outerLayer_mainArea {
    .mainArea_ul {
      display: flex;
      flex-wrap: wrap;
      padding: 0px;
      margin: 0px;
      .ul_li {
        // width: 230px;
        // height: 80px;
        box-shadow: 0px 0px 2px #888686;
        border-radius: 9px;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        margin: 10px;
        position: relative;

        .li_left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-size: 13px;
        }

        .li_right {
          display: flex;
          flex-direction: column;
          width: 60px;
          height: 100%;
          background-color: rgb(218, 218, 218);
          align-items: center;
          justify-content: space-around;
          font-size: 13px;
          .right_icon {
            font-size: 28px;
            cursor: pointer;
            color: #888686;
            &:hover {
              color: black;
            }
          }
        }
        &.active {
          box-shadow: 0px 0px 5px #0fcf18;
          .implicit {
            display: flex;
          }
        }
        &:not(.active):hover {
          box-shadow: 0px 0px 5px #0fcf18;
          .implicit {
            display: flex;
          }
        }

        .implicit {
          position: absolute;
          width: 21px;
          height: 21px;
          border-radius: 50%;
          box-shadow: 0px 0px 2px black;
          display: none;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background-color: #fff;
          top: 2px;
          right: 2px;
          &:hover {
            box-shadow: 0px 0px 5px #0fcf18;
          }
          i {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
